/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import {
  Loader,
  Modal,
  Checkbox,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import cx from 'classnames';
import api from '../../api';
//import Footer from '../Footer/Footer';
import { convertPropertiesToCamelCase } from '../../utils/shared';
import WithRouter from '../Extensions/WithRouter';

class LeakageSetting extends Component {
  constructor(props) {
    super(props);
    this.modalAction = null;
    this.modalBody = null;
    this.state = {
      isLoading: false,
      isUseLeakage: false,
      isOpenModal: false,
      isOpenAlert: false,
      isUseTelephone: false,
      isUseEmail: false,
      isUseIpv4: false,
      isUseIpv6: false,
      isUseUrl: false,
      isUsePassword: false || 'off',
      isUseKeyinfo: false,
    };
    this.handleLeakageToggle = this.handleLeakageToggle.bind(this);
    this.handleSaveModal = this.handleSaveModal.bind(this);
    this.handleLeakageCheckChange = this.handleLeakageCheckChange.bind(this);
    this.updateLeakageStatus = this.updateLeakageStatus.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    this.getLeakageStatus();
  }

  componentDidUpdate(prevProps, prevState) {
    const { isUseLeakage } = this.state;

    if (prevState.isUseLeakage !== isUseLeakage) {
      const element = document.getElementsByClassName('setting_issues_bottom');
      if (element.length === 0) {
        return;
      }
      if (isUseLeakage) {
        element[0].style.setProperty('bottom', '-260px');
      } else {
        element[0].style.setProperty('bottom', '-505px');
      }
    }
  }

  handleLeakageCheckChange(e, { value }) {
    const {
      isUseTelephone,
      isUseEmail,
      isUseIpv4,
      isUseIpv6,
      isUseUrl,
      isUsePassword,
      isUseKeyinfo,
    } = this.state;

    if (value === 'telephone') {
      this.setState({
        isUseTelephone: !isUseTelephone,
      });
    }

    if (value === 'email') {
      this.setState({
        isUseEmail: !isUseEmail,
      });
    }

    if (value === 'ipv4') {
      this.setState({
        isUseIpv4: !isUseIpv4,
      });
    }

    if (value === 'ipv6') {
      this.setState({
        isUseIpv6: !isUseIpv6,
      });
    }

    if (value === 'url') {
      this.setState({
        isUseUrl: !isUseUrl,
      });
    }

    if (value === 'password') {
      this.setState({
        isUsePassword: !isUsePassword,
      });
    }

    if (value === 'keyinfo') {
      this.setState({
        isUseKeyinfo: !isUseKeyinfo,
      });
    }
  }

  handleLeakageToggle(e) {
    const { t, state } = this.props;
    const { isUseLeakage } = this.state;
    const { isAdmin } = state.user;

    if (!isAdmin) {
      return;
    }

    if (e.target.text === t('modal.button.on')) {
      if (isUseLeakage) {
        return;
      }
      return this.setState({
        isUseLeakage: true,
      });
    }
    if (!isUseLeakage) {
      return;
    }
    return this.setState({
      isUseLeakage: false,
    });
  }

  handleSaveModal() {
    const { t } = this.props;
    this.modalAction = t('modal.title.attention');
    this.modalBody = t('settings.message.save_setting');
    this.setState({
      isOpenModal: true,
    });
  }

  getLeakageStatus() {
    const { t } = this.props;
    this.setState({
      isLoading: true,
    }, () => {
      api
        .getLeakageStatus()
        .then((response) => {
          const res = convertPropertiesToCamelCase(response.response);
          const { leakageSetting, useLeakage } = res;
          this.setState({
            isLoading: false,
            isUseLeakage: useLeakage,
            isUseTelephone: leakageSetting.telephone,
            isUseEmail: leakageSetting.email,
            isUseIpv4: leakageSetting.ipv4,
            isUseIpv6: leakageSetting.ipv6,
            isUseUrl: leakageSetting.url,
            isUsePassword: leakageSetting.password,
            isUseKeyinfo: leakageSetting.keyinfo,
          });
        })
        .catch((err) => {
          console.log(err);
          this.modalAction = t('modal.title.attention');
          this.modalBody = t('settings.message.user_not_permitted');
          this.setState({
            isLoading: false,
            isOpenAlert: true,
          });
        });
    });
  }

  updateLeakageStatus() {
    const { t } = this.props;
    const {
      isUseLeakage,
      isUseTelephone,
      isUseEmail,
      isUseIpv4,
      isUseIpv6,
      isUseUrl,
      isUsePassword,
      isUseKeyinfo,
    } = this.state;
    let data;

    if (isUseLeakage) {
      data = {
        use_leakage: isUseLeakage,
        leakage_setting: {
          telephone: isUseTelephone,
          email: isUseEmail,
          ipv4: isUseIpv4,
          ipv6: isUseIpv6,
          url: isUseUrl,
          password: isUsePassword,
          keyinfo: isUseKeyinfo,
        }
      };
    } else {
      data = {
        use_leakage: isUseLeakage,
      };
    }

    this.setState({
      isOpenModal: false,
      isLoading: true,
    }, () => {
      api
        .updateLeakageStatus(data)
        .then((response) => {
          const res = convertPropertiesToCamelCase(response.response);
          localStorage.setItem('use_leakage', res.useLeakage);

          this.setState({
            isLoading: false,
            isUseLeakage: res.useLeakage,
          });
        })
        .catch((err) => {
          console.log(err);
          this.modalAction = t('modal.title.attention');
          this.modalBody = t('settings.message.user_not_permitted');
          this.setState({
            isLoading: false,
            isOpenAlert: true,
          });
        });
    });
  }

  closeModal() {
    this.setState({
      isOpenModal: false,
      isOpenAlert: false,
    });
  }

  render() {
    const {
      isLoading,
      isUseLeakage,
      isUseTelephone,
      isUseEmail,
      isUseIpv4,
      isUseIpv6,
      isUseUrl,
      isUsePassword,
      isUseKeyinfo,
    } = this.state;
    const { t } = this.props;
    const { isAdmin } = this.props.state.user;

    const renderIfReady = (element) => {
      return isLoading ? (
        <div className="loader_container">
          <Loader size="big" style={{ display: 'block', lineHeight: '25px' }}>
            {t('list.title.loading')}
          </Loader>
        </div>
      ) : (
        element
      );
    };

    return (
      <div className="setting_issue_main" style={{ position: 'relative' }}>
        <div className="contents_header">
          <div className="contents_header_inner">
            <h3 className="content_title">{t('settings.list.leakage_setting')}</h3>
          </div>
        </div>
        {renderIfReady(
          <div className="setting_issues_content">
            <div className="setting_issues_content_item_wrap">
              <h3>
                {t('settings.list.leakage_information_check')}
              </h3>
              <div className="setting_issues_content_item">
                {
                  isAdmin ? (
                    <div className="switch">
                      <a
                        className={cx(
                          {
                            checked: isUseLeakage,
                          }
                        )}
                        onClick={this.handleLeakageToggle}
                        onKeyUp={this.handleLeakageToggle}
                      >
                        {t('modal.button.on')}
                      </a>
                      <a
                        className={cx(
                          {
                            checked: !isUseLeakage,
                          }
                        )}
                        onClick={this.handleLeakageToggle}
                        onKeyUp={this.handleLeakageToggle}
                      >
                        {t('modal.button.off')}
                      </a>
                    </div>
                  ) : (
                    <div className="switch">
                      <a
                        className={cx(
                          {
                            checked: isUseLeakage,
                          },
                          'disable'
                        )}
                      >
                        {t('modal.button.on')}
                      </a>
                      <a
                        className={cx(
                          {
                            checked: !isUseLeakage,
                          },
                          'disable'
                        )}
                      >
                        {t('modal.button.off')}
                      </a>
                    </div>
                  )
                }
                {
                  isUseLeakage ? (
                    <p className="text">
                      {t('settings.message.use_leakage')}
                    </p>
                  ) : (
                    <p className="text">
                      {t('settings.message.not_use_leakage')}
                    </p>
                  )
                }
              </div>
            </div>
            {
              isUseLeakage ? (
                <div className="setting_issues_content_item_wrap">
                  <h3>
                    {t('modal.leakage_info.leakage_type')}
                  </h3>
                  <div className="setting_issues_content_item">
                    <ul className="options">
                      <li>
                        <Checkbox
                          label={t('modal.leakage_info.telephone')}
                          value="telephone"
                          checked={isUseTelephone}
                          onChange={this.handleLeakageCheckChange}
                          readOnly={!isAdmin}
                        />
                      </li>
                      <li>
                        <Checkbox
                          label={t('modal.leakage_info.email')}
                          value="email"
                          checked={isUseEmail}
                          onChange={this.handleLeakageCheckChange}
                          readOnly={!isAdmin}
                        />
                      </li>
                      <li>
                        <Checkbox
                          label={t('modal.leakage_info.ipv4')}
                          value="ipv4"
                          checked={isUseIpv4}
                          onChange={this.handleLeakageCheckChange}
                          readOnly={!isAdmin}
                        />
                      </li>
                      <li>
                        <Checkbox
                          label={t('modal.leakage_info.ipv6')}
                          value="ipv6"
                          checked={isUseIpv6}
                          onChange={this.handleLeakageCheckChange}
                          readOnly={!isAdmin}
                        />
                      </li>
                      <li>
                        <Checkbox
                          label={t('modal.leakage_info.url')}
                          value="url"
                          checked={isUseUrl}
                          onChange={this.handleLeakageCheckChange}
                          readOnly={!isAdmin}
                        />
                      </li>
                      <li>
                        <Checkbox
                          label={t('modal.leakage_info.password')}
                          value="password"
                          checked={isUsePassword}
                          onChange={this.handleLeakageCheckChange}
                          readOnly={!isAdmin}
                        />
                      </li>
                      <li>
                        <Checkbox
                          label={t('modal.leakage_info.key_info')}
                          value="keyinfo"
                          checked={isUseKeyinfo}
                          onChange={this.handleLeakageCheckChange}
                          readOnly={!isAdmin}
                        />
                      </li>
                    </ul>
                  </div>
                </div>
              ) : null
            }
            {
              isAdmin ? (
                <div className="setting_issues_bottom" style={{ bottom: '-260px', position: 'absolute' }}>
                  <a className="save" onClick={this.handleSaveModal} onKeyUp={this.handleSaveModal}>{t('modal.button.save')}</a>
                </div>
              ) : null
            }
          </div>
        )}
        <Modal open={this.state.isOpenModal} onClose={this.closeModal}>
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              <div className="modal_popup confirm">
                <h2 className="title">{this.modalAction}</h2>
                <p className="text">{this.modalBody}</p>
                <div className="button_wrap">
                  <a className="left_button" onClick={this.closeModal} onKeyUp={this.closeModal}>
                    {t('modal.button.cancel')}
                  </a>
                  <a className="right_button" onClick={this.updateLeakageStatus} onKeyUp={this.updateLeakageStatus}>
                    {t('modal.button.save')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal open={this.state.isOpenAlert} onClose={this.closeModal}>
          <div className="modal_popup_wrap">
            <div className="modal_popup_box">
              <div className="modal_popup">
                <h2 className="title">{this.modalAction}</h2>
                <p className="text">{this.modalBody}</p>
                <div className="button_wrap">
                  <a
                    className="center_button"
                    style={{ cursor: 'pointer' }}
                    onClick={this.closeModal}
                    onKeyUp={this.closeModal}
                  >
                    {t('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default WithRouter(withTranslation()(inject('state')(observer(LeakageSetting))));
